import { render, staticRenderFns } from "./SchemaField.vue?vue&type=template&id=62b68c06&scoped=true"
import script from "./SchemaField.vue?vue&type=script&lang=ts"
export * from "./SchemaField.vue?vue&type=script&lang=ts"
import style0 from "./SchemaField.vue?vue&type=style&index=0&id=62b68c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b68c06",
  null
  
)

export default component.exports